import React, { Component } from 'react';

import './styles.less';

export default class HintTooltip extends Component {
  render() {
    const { content } = this.props;

    return (
      <div className="hint-tooltip">
        <p
          className="hint-tooltip-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    );
  }
}
